"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, urls, id, values, is_admin) {
  $scope.save = function() {
    if (id != null) {
      $scope.update(id);
    } else {
      $scope.create();
    }
  };
  $scope.create = function() {
    $http.post('/api/user.json', angular.toJson($scope.user)).then(function(response) {
      window.location = '/user';
    }, function(response) {
      alert("Error saving!");
    });
  };
  $scope.update = function(id) {
    $http.post('/api/user/' + id + '.json', angular.toJson($scope.user)).then(function(response) {
      window.location = '/user';
    }, function(response) {
      alert("Error saving!");
    });
  };
  $scope.$watch('title', function() {
    if (hlp.isSet($scope.id) && hlp.isSet($scope.title)) {
      window.document.title = $scope.title + " - Benutzer";
    }
  }, true);
  var init = function() {
    $scope.urls = urls;
    $scope.id = id;
    $scope.is_admin = is_admin;
    if (values != "") {
      $scope.user = JSON.parse(values);
      $scope.title = $scope.user.name;
    } else {
      $scope.user = {};
      $scope.title = "";
    }
    $scope.roles = [{
      "id": 'USER',
      "label": 'Nutzer'
    }, {
      "id": 'SYSADMIN',
      "label": 'Systemadminstrator'
    }, {
      "id": 'ADMIN',
      "label": 'Administrator'
    }, {
      "id": 'COLLECTION',
      "label": 'Sammlungen'
    }, {
      "id": 'EDIT_WORK',
      "label": 'Werke bearbeiten'
    }, {
      "id": 'EDIT_THESAURUS',
      "label": 'Thesaurus bearbeiten'
    }, {
      "id": 'EXPORT',
      "label": 'Export'
    }, {
      "id": 'IMPORT',
      "label": 'Import'
    }, {
      "id": 'EDIT_DESCRIPTION',
      "label": 'Beschreibung bearbeiten'
    }, {
      "id": 'PICTURE_IMPORT',
      "label": 'Bild Import'
    }, {
      "id": 'ATTACHMENT_IMPORT',
      "label": 'Anhang Import'
    }, {
      "id": 'EDIT_REGISTRATION',
      "label": 'Bilderfassung bearbeiten'
    }, {
      "id": 'EDIT_PUBLIC_COLLECTION',
      "label": 'Öffentliche Sammlung bearbeiten'
    }, {
      "id": 'WORKFLOW_MANAGER',
      "label": 'Bearbeitungen zurücksetzen'
    }];
  }();
};
module.exports = controller;
